// config/modulos.js — catálogo de módulos y feature flags en el frontend.
// Cada módulo define su nombre, icono (react-icons/fi) y ruta.
// La visibilidad real depende de: empresa.modulos[clave] === true
// y de los permisos del usuario.
import {
  FiGrid, FiUsers, FiCalendar, FiTruck, FiFileText, FiPackage,
  FiClock, FiUserCheck, FiCheckSquare, FiLogIn, FiSun, FiCoffee, FiBriefcase,
  FiBarChart2, FiFolder, FiTrendingUp, FiAlertTriangle,
} from 'react-icons/fi';

export const MODULOS = [
  { clave: 'dashboard', nombre: 'Panel de control', icono: FiGrid, ruta: '/app', core: true },
  { clave: 'clientes', nombre: 'Clientes', icono: FiUsers, ruta: '/app/clientes' },
  { clave: 'presupuestos', nombre: 'Presupuestos y facturas', icono: FiFileText, ruta: '/app/presupuestos' },
  { clave: 'clientes_potenciales', nombre: 'Clientes potenciales', icono: FiTrendingUp, ruta: '/app/clientes-potenciales', core: true },
  { clave: 'citas', nombre: 'Citas', icono: FiCalendar, ruta: '/app/citas' },
  { clave: 'calendario', nombre: 'Calendario', icono: FiCalendar, ruta: '/app/calendario', core: true },
  { clave: 'archivos', nombre: 'Archivos', icono: FiFolder, ruta: '/app/archivos', core: true },
  { clave: 'citas_itv', nombre: 'Citas ITV', icono: FiTruck, ruta: '/app/citas-itv' },
  { clave: 'almacen', nombre: 'Almacén', icono: FiPackage, ruta: '/app/almacen' },
  { clave: 'reservas', nombre: 'Reservas y aforo', icono: FiClock, ruta: '/app/reservas' },
  { clave: 'equipo', nombre: 'Equipo', icono: FiUserCheck, ruta: '/app/equipo' },
  { clave: 'tareas', nombre: 'Tareas', icono: FiCheckSquare, ruta: '/app/tareas' },
  { clave: 'incidencias', nombre: 'Incidencias', icono: FiAlertTriangle, ruta: '/app/incidencias' },
  { clave: 'fichajes', nombre: 'Fichajes', icono: FiLogIn, ruta: '/app/fichajes' },
  { clave: 'monitor_actividad', nombre: 'Monitor de actividad', icono: FiBarChart2, ruta: '/app/monitor-actividad' },
  { clave: 'vacaciones', nombre: 'Vacaciones', icono: FiSun, ruta: '/app/vacaciones' },
  { clave: 'proyectos', nombre: 'Proyectos y obras', icono: FiBriefcase, ruta: '/app/proyectos' },
  { clave: 'restaurante', nombre: 'Restaurante', icono: FiCoffee, ruta: '/app/restaurante' },
];

export const FEATURE_FLAGS = {
  itv_adelantador: { clave: 'itv_adelantador', nombre: 'Adelantador ITV', descripcion: 'Monitor de citas y recordatorios para revisiones ITV', categoria: 'taller' },
  notificaciones_whatsapp: { clave: 'notificaciones_whatsapp', nombre: 'Notificaciones WhatsApp', descripcion: 'Avisos automáticos a clientes por WhatsApp', categoria: 'comunicacion' },
  facturacion_verifactu: { clave: 'facturacion_verifactu', nombre: 'Facturación Verifactu', descripcion: 'Cumplimiento y emisión de facturas electrónicas', categoria: 'facturacion' },
  certificaciones_obra: { clave: 'certificaciones_obra', nombre: 'Certificaciones de obra', descripcion: 'Facturación por porcentaje de avance de la obra', categoria: 'reforma' },
  coste_real_obra: { clave: 'coste_real_obra', nombre: 'Coste real por obra', descripcion: 'Cruce de horas, materiales y facturación para margen real', categoria: 'reforma' },
  fichajes_por_obra: { clave: 'fichajes_por_obra', nombre: 'Fichajes por obra', descripcion: 'Asignación de horas y coste laboral por obra', categoria: 'rrhh' },
  stock_minimo_alertas: { clave: 'stock_minimo_alertas', nombre: 'Alertas de stock mínimo', descripcion: 'Notificaciones al quedarse sin stock en almacén', categoria: 'almacen' },
  qr_mesa: { clave: 'qr_mesa', nombre: 'QR de mesa', descripcion: 'Pedidos desde la mesa por QR con monitor del restaurante', categoria: 'restaurante' },
  firma_digital: { clave: 'firma_digital', nombre: 'Firma digital', descripcion: 'Permite enviar presupuestos y facturas para firma digital por parte del cliente', categoria: 'documentacion' },
};

export const TIPOS_NEGOCIO = {
  general: { nombre: 'General', featureFlags: [] },
  taller: { nombre: 'Taller mecánico', featureFlags: ['itv_adelantador', 'notificaciones_whatsapp', 'facturacion_verifactu', 'stock_minimo_alertas', 'fichajes_por_obra'] },
  reforma: { nombre: 'Reformas / albañilería', featureFlags: ['notificaciones_whatsapp', 'facturacion_verifactu', 'certificaciones_obra', 'coste_real_obra', 'fichajes_por_obra', 'stock_minimo_alertas'] },
  electricista: { nombre: 'Pymes electricistas', featureFlags: ['notificaciones_whatsapp', 'facturacion_verifactu', 'certificaciones_obra', 'coste_real_obra', 'fichajes_por_obra', 'stock_minimo_alertas'] },
  restaurante: { nombre: 'Restaurante', featureFlags: ['notificaciones_whatsapp', 'facturacion_verifactu', 'stock_minimo_alertas', 'qr_mesa'] },
};

export const PLANES = {
  starter: {
    nombre: 'Starter',
    descripcion: 'Ideal para negocios básicos y primeras operaciones.',
    precio: 29,
    precioAnual: 24,
    mercado: 'Micro negocios y comercios locales',
    featureFlags: ['notificaciones_whatsapp'],
  },
  pro: {
    nombre: 'Pro',
    descripcion: 'Para empresas que necesitan stock, facturación y automatización.',
    precio: 69,
    precioAnual: 59,
    mercado: 'Pymes con operación diaria y volumen medio',
    featureFlags: ['notificaciones_whatsapp', 'stock_minimo_alertas', 'facturacion_verifactu'],
  },
  premium: {
    nombre: 'Premium',
    descripcion: 'Solución completa para talleres, reformas y negocio con alta demanda.',
    precio: 119,
    precioAnual: 99,
    mercado: 'Empresas con gestión más compleja, múltiples procesos y clientes',
    featureFlags: ['notificaciones_whatsapp', 'stock_minimo_alertas', 'facturacion_verifactu', 'itv_adelantador', 'certificaciones_obra', 'coste_real_obra', 'qr_mesa'],
  },
  custom: {
    nombre: 'Custom',
    descripcion: 'Configuración a medida para operaciones complejas o multisector.',
    precio: null,
    precioAnual: null,
    mercado: 'Operaciones únicas o multi-sucursal con personalización profunda',
    featureFlags: [],
  },
};

export function getPlanInfo(plan = 'starter') {
  return PLANES[plan] || PLANES.starter;
}

export function featureFlagEnabled(empresa, clave) {
  const featureFlags = empresa?.featureFlags || {};
  return featureFlags[clave] === true;
}

export function featureFlagsPorDefecto(tipoNegocio = 'general', plan = 'starter') {
  const defaults = {};
  Object.keys(FEATURE_FLAGS).forEach((clave) => {
    defaults[clave] = false;
  });

  const tipo = TIPOS_NEGOCIO[tipoNegocio] || TIPOS_NEGOCIO.general;
  const paquete = PLANES[plan] || PLANES.starter;

  [...tipo.featureFlags, ...paquete.featureFlags].forEach((clave) => {
    if (Object.prototype.hasOwnProperty.call(defaults, clave)) {
      defaults[clave] = true;
    }
  });

  return defaults;
}

export function modulosPorDefecto() {
  return MODULOS.reduce((acc, modulo) => {
    acc[modulo.clave] = Boolean(modulo.core);
    return acc;
  }, {});
}

// Devuelve los módulos visibles para un usuario/empresa dados
export function modulosVisibles(usuario, empresa) {
  if (!usuario) return [];

  // Superadmin ve todo
  if (usuario.rol === 'superadmin') return MODULOS;

  const activos = empresa?.modulos || {};

  return MODULOS.filter((m) => {
    if (m.oculto) return false;
    if (m.core) return true;
    if (activos[m.clave] !== true) return false; // módulo no contratado

    // Admin ve todos los módulos activos de su empresa
    if (usuario.rol === 'admin') return true;

    // Empleado: necesita al menos permiso de "ver" en el módulo
    const permiso = (usuario.permisos || []).find((p) => p.modulo === m.clave);
    return permiso && permiso.acciones.includes('ver');
  });
}
